import { render, staticRenderFns } from "./ProductFilter.vue?vue&type=template&id=0ab68971&"
import script from "./ProductFilter.ts?vue&type=script&lang=ts&"
export * from "./ProductFilter.ts?vue&type=script&lang=ts&"
import style0 from "./ProductFilter.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import {QRange,QSlider} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QRange,QSlider})
